<template>
  <NormalHeaderLayout header="About Dashboard for Autonomous System Health">
    <p>At APNIC, we have been working to provide you with information about suspicious traffic coming from your network. Have a look at our video and discover all the information available in DASH. After watching it, log in to discover your Dashboard for Autonomous System Health.</p>
    <p>
      <i>
        <strong>Please note that this version of DASH is a prototype for the purposes of conducting usability testing and gathering feedback. We would really appreciate if you could participate in the survey through the Feedback button on the right of this screen.</strong>
      </i>
    </p>

    <button class="btn btn-primary ga__login-btn" @click="authenticateOidc">APNIC Login</button>
    <VideoModal></VideoModal>
  </NormalHeaderLayout>
</template>

<script>
import { mapActions } from 'vuex';
import NormalHeaderLayout from '../components/layout/NormalHeaderLayout';
import VideoModal from '../components/VideoModal';

export default {
  methods: {
    ...mapActions('authStore', ['authenticateOidc'])
  },
  components: {
    NormalHeaderLayout,
    VideoModal
  }
};
</script>

<style scoped lang="scss">
.btn {
  margin: 30px 0 50px 0;
}
</style>
